var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTransparentGraphic = function SvgTransparentGraphic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.125 0.125H2.875C1.3625 0.125 0.125 1.3625 0.125 2.875V22.125C0.125 23.6375 1.3625 24.875 2.875 24.875H22.125C23.6375 24.875 24.875 23.6375 24.875 22.125V2.875C24.875 1.3625 23.6375 0.125 22.125 0.125ZM22.125 22.125H2.875V2.875H22.125V22.125ZM8.375 9.75H5.625V19.375H8.375V9.75ZM11.125 5.625H13.875V19.375H11.125V5.625ZM19.375 13.875H16.625V19.375H19.375V13.875Z",
    fill: "#F89C3A"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransparentGraphic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transparent-graphic.398c1aa7.svg";
export { ForwardRef as ReactComponent };